import useCampaignFlows from "../datahooks/useCampaignFlows";

import type { CampaignFlow } from "../types";

export default function useFlowsActions(
  flows: CampaignFlow[],
  setSelectedFlowIndex: (selectedFlowIndex: number) => void,
) {
  const { addSecondFlow, deleteCampaignFlow } = useCampaignFlows();

  function addFlow() {
    const messageFlow: CampaignFlow = {
      id: null,
      name: "Message Flow B",
      type: "PRIMARY_MESSAGE",
      translate: false,
      source_language: null,
      is_manual_language: false,
      flow_message_templates: [],
      template: null,
      // 14 days
      withdraw_delay: 1209600000,
      like_delay: null,
      endorse_delay: null,
      endorse_enabled: false,
      like_type: "LIKE",
      like_enabled: false,
    };

    const connectFlow: CampaignFlow = {
      ...messageFlow,
      type: "PRIMARY_CONNECT",
      name: "Connection Flow B",
    };

    const secondFlow =
      flows[0].type === "PRIMARY_CONNECT" ? connectFlow : messageFlow;

    addSecondFlow({ flow: secondFlow }).then(() => setSelectedFlowIndex(1));
  }

  function deleteFlow(flowId: string) {
    setSelectedFlowIndex(0);
    deleteCampaignFlow({ flowId }, { onError: () => setSelectedFlowIndex(1) });
  }

  function duplicateFlow() {
    const {
      type,
      flow_message_templates: messageTemplates,
      ...rest
    } = flows[0];

    const flowName =
      type === "PRIMARY_CONNECT" ? "Connection Flow B" : "Message Flow B";

    const validMessageTemplates = messageTemplates.filter(
      (messageTemplate) => messageTemplate.original_id,
    );

    addSecondFlow({
      flow: {
        ...rest,
        flow_message_templates: validMessageTemplates,
        type,
        name: flowName,
      },
    }).then(() => setSelectedFlowIndex(1));
  }

  return {
    addFlow,
    duplicateFlow,
    deleteFlow,
  };
}
